import { Id } from "./id";

type ConfigurationProfile = {
  name: string;
  roles: Id[];
  columns: { key: string }[];
};

type TimeRecordsListingConfiguration = ConfigurationProfile[];

const timeRecordsListingConfiguration: TimeRecordsListingConfiguration = [];

export type { TimeRecordsListingConfiguration };

export { timeRecordsListingConfiguration };
